module.exports = __webpack_public_path__ + "static/dancing-after-the-rain_acrylic-on-recycled-wood-135x135in-2016-bc3e26ba3a710e00a86cbc3ccb665e82.jpg";